import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { serviceApi } from '~/features';
import { CampaignExportDto, ExportResponse } from '~/types';

async function downloadSimplifiedReportApi({
  IdAdvertiser,
  CampaignIds,
}: CampaignExportDto): Promise<ExportResponse> {
  const response: AxiosResponse<Blob> = await serviceApi.get(
    `/Report/Campaigns-Export`,
    {
      params: {
        IdAdvertiser,
        CampaignIds,
      },
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    }
  );

  return {
    data: response.data,
    headers: {
      'content-type':
        response.headers['content-type'] ||
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': response.headers['content-disposition'],
    },
  };
}

async function downloadDetailedReportApi({
  IdAdvertiser,
  CampaignIds,
}: CampaignExportDto): Promise<ExportResponse> {
  const response: AxiosResponse<Blob> = await serviceApi.get(
    `/Report/export-excel-multiple-Campaigns`,
    {
      params: {
        IdAdvertiser,
        CampaignIds,
      },
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    }
  );

  return {
    data: response.data,
    headers: {
      'content-type':
        response.headers['content-type'] ||
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': response.headers['content-disposition'],
    },
  };
}

export function useDownloadSimplifiedReport(
  onSuccess?: (data: ExportResponse) => void,
  onError?: (error: Error) => void
) {
  return useMutation({
    mutationFn: downloadSimplifiedReportApi,
    onSuccess,
    onError,
  });
}

export function useDownloadDetailedReport(
  onSuccess?: (data: ExportResponse) => void,
  onError?: (error: Error) => void
) {
  return useMutation({
    mutationFn: downloadDetailedReportApi,
    onSuccess,
    onError,
  });
}
